import { CreditCard } from '../models/credit-card';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { EntityEnum } from '../enum/entity.enum';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageResponse } from '../interfaces/page-response';

@Injectable({ providedIn: 'root' })
export class CreditCardService extends EntityCollectionServiceBase<CreditCard> {

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super(EntityEnum.CREDIT_CARD, serviceElementsFactory);
    }

    all(): Observable<PageResponse<CreditCard>> {
        const headers = new HttpHeaders({ Accept: 'application/ld+json' });
        return this.http.get<any>(`${environment.apiUrl}/credit_cards`, { headers }).pipe(
            map(r => ({
                totalItems: r['hydra:totalItems'],
                page: r['hydra:member']
            })),
            tap((result) => this.addManyToCache(result.page))
        );
    }
}
